// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Analytics40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Analytics40: FC<Analytics40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M7.778 35c-.75 0-1.4-.276-1.952-.826-.55-.551-.826-1.202-.826-1.952V5h2.778v27.222H35V35H7.778Zm2.639-5.417V15.306h5.527v14.277h-5.527Zm8.278 0V6.806h5.527v22.777h-5.527Zm8.166 0v-7.5h5.528v7.5H26.86Z" />
        </svg>
    );
};

export default Analytics40;
